import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { ArrowLeft, Button } from "@theprelude/ds";
import { Suspense } from "react";
import { setPageTitle } from "@/components/app-shell/app-shell";
import MetricCards, {
  MetricsLoading,
} from "@/components/dashboard/metric-cards";
import { authorizeFeatures } from "@/lib/authorize-feature";

export const Route = createFileRoute("/_app/dashboard")({
  beforeLoad: async ({ context }) => {
    setPageTitle("Dashboard");
    await authorizeFeatures(context, ["detect"]);
  },
  component: DashboardLayout,
});

function DashboardLayout() {
  return (
    <>
      <div className="flex flex-col gap-4 bg-secondary-background px-4 py-4 md:flex-row dark:drop-shadow-[12px_12px_15px_rgba(0,0,0,0.25)]">
        <Link to="/dashboard">
          <Button
            intent="pill"
            icon={<ArrowLeft className="text-secondary-foreground" />}
          >
            Back to Dashboard
          </Button>
        </Link>
      </div>
      <section className="px-4 pt-6">
        <Suspense fallback={<MetricsLoading />}>
          <MetricCards grayOut />
        </Suspense>
      </section>
      <section className="flex flex-1 flex-col overflow-hidden px-4 py-6 pb-1">
        <Outlet />
      </section>
    </>
  );
}
